var render = function render(){var _vm=this,_c=_vm._self._c;return _c('app-card',{attrs:{"title":_vm.parseAttribute(_vm.string)}},[_c('v-container',[(_vm.skeleton)?_c('v-skeleton-loader',{staticClass:"pa-2",attrs:{"type":"article@2"}}):_c('v-row',{staticStyle:{"min-height":"200px"}},[_c('v-col',{attrs:{"cols":"12"}},[_c('div',{domProps:{"innerHTML":_vm._s(_vm.text)}})])],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }